export const copy = {
  tooltip: {
    description: "Click here to attach a file.",
    fileLimit: (maxFileSize: number): string => `File limit: ${maxFileSize} MB`,
    files: (acceptedFileTypes: string[]): string =>
      `Accepted file types: ${acceptedFileTypes.join(", ")}`,
  },
};
